import { render, staticRenderFns } from "./BootstrapComponent.vue?vue&type=template&id=e0c1db80&scoped=true&"
import script from "./BootstrapComponent.vue?vue&type=script&lang=js&"
export * from "./BootstrapComponent.vue?vue&type=script&lang=js&"
import style0 from "./BootstrapComponent.vue?vue&type=style&index=0&id=e0c1db80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0c1db80",
  null
  
)

export default component.exports